export default "__VITE_ASSET__2cad12e1__"